import { DEFAULT_GRID_SIZE, NON_MODIFYING_QUERY_PARAMETERS } from '@common/Listing/helpers/constants';

export const PAGE_KEY = 'page';

/**
 * eg: /toej-til-kvinder/toej_color=10 -> color
 */
export const getBaseFilterFromIndexableUrl = (url) => {
    if (!url?.includes('_') || !url?.includes('=')) {
        return null;
    }

    return url.split('_').pop().split('=')[0];
};

export const getDefaultQueryParamsKeys = (parameters, productsPerPage) => {
    const defaultModificationParams = {
        page: 1,
        limit: productsPerPage,
        grid: DEFAULT_GRID_SIZE
    };
    const keys = Object.keys(defaultModificationParams);

    return keys.filter((key) => {
        const value = parameters[key];
        const defaultValue = defaultModificationParams[key];
        return value === defaultValue;
    });
};

/**
 * Returns true if other filters than: 'page', 'limit', 'grid' were applied
 *
 * @param requestParametersKeys
 */
export const areModifyingFiltersApplied = requestParametersKeys => (
    requestParametersKeys.some(key => !NON_MODIFYING_QUERY_PARAMETERS.includes(key))
);

export const getUpdatedCanonicalUrl = (canonicalUrl, requestParameters, currentPage) => {
    const indexableFiltersKey = getBaseFilterFromIndexableUrl(canonicalUrl);
    const requestParametersKeys = Object.keys(requestParameters);
    const paramsWithoutIndexableFilter = requestParametersKeys.filter(item => item !== indexableFiltersKey);

    if (!areModifyingFiltersApplied(paramsWithoutIndexableFilter) && currentPage > 1) {
        return `${canonicalUrl}?${PAGE_KEY}=${currentPage}`;
    }

    return canonicalUrl;
};
